(function () {
	/* ------------------------------------------------------------------ */
	/* 1. Helper – update the rating summary that lives inside #header     */
	/* ------------------------------------------------------------------ */
	function updateHeaderSummary() {
		/* average “4.x” ➜ 4.7 ------------------------------------------ */
		const avgEl = document.querySelector(
			'#header [data-testid="rating-summary-avg"]'
		);
		if (avgEl && !avgEl.dataset.updated) {
			/* a11y (screen-reader) value */
			avgEl.setAttribute('aria-label', '4.8');

			/* visual number (Loox only shows stars) – add if missing */
			if (!avgEl.querySelector('.avg-number')) {
				avgEl.insertAdjacentHTML(
					'beforeend',
					'<span class="avg-number" style="margin-left:4px;font-weight:normal">4.8</span>'
				);
			}
			avgEl.dataset.updated = 'true';
		}

		/* count “(xxx Recensioner)” ➜ 1219 Recensioner --------------- */
		const cntSpan = document.querySelector(
			'#header [data-testid="rating-summary-count"] span'
		);
		if (cntSpan && !cntSpan.dataset.updated) {
			cntSpan.textContent = '1243 Recensioner';
			cntSpan.style.fontWeight = 'normal';
			cntSpan.dataset.updated = 'true';
		}
	}

	/* ------------------------------------------------------------------ */
	/* 2. Original mutation handler + our new helper                       */
	/* ------------------------------------------------------------------ */
	function handleMutations(mutationsList) {
		for (const mutation of mutationsList) {
			if (mutation.type !== 'childList') continue;

			/* ---------- Function 1: .loox-rating-label ---------------- */
			document
				.querySelectorAll('.loox-rating .loox-rating-label')
				.forEach((looxRatingLabel) => {
					if (looxRatingLabel.dataset.updated) return;

					/* rating “4.x” ➜ 4.7 */
					looxRatingLabel.innerHTML = looxRatingLabel.innerHTML.replace(
						/4\.\d/,
						'4.8'
					);

					/* count inside .greyed-out or (…) */
					const greyedOut = looxRatingLabel.querySelector('.greyed-out');
					if (greyedOut) {
						greyedOut.innerHTML = '(1243)';
					} else {
						looxRatingLabel.innerHTML = looxRatingLabel.innerHTML.replace(
							/\(.*?\)/,
							'(1243 recensioner)'
						);
					}

					looxRatingLabel.style.fontWeight = 'normal';
					looxRatingLabel.dataset.updated = 'true';
				});

			/* ---------- Function 2: trust-badge widget ---------------- */
			document
				.querySelectorAll('.loox-trust-badge-container')
				.forEach((container) => {
					const average = container.querySelector(
						'.loox-trust-badge-widget-ratings__average-rating'
					);
					const count = container.querySelector(
						'.loox-trust-badge-widget-ratings__raters-count'
					);
					const title = container.querySelector(
						'.loox-trust-badge-widget-ratings__raters-title'
					);
					const paper = container.querySelector(
						'.loox-trust-badge-widget.lxs-paper'
					);

					if (average && !average.dataset.updated) {
						average.textContent = '4.8';
						average.style.fontWeight = 'normal';
						average.dataset.updated = 'true';
					}
					if (count && !count.dataset.updated) {
						count.textContent = '1243';
						count.style.fontWeight = 'normal';
						count.dataset.updated = 'true';
					}
					if (title && !title.dataset.updated) {
						title.style.fontWeight = 'normal';
						title.dataset.updated = 'true';
					}

					/* responsive font-size only once ------------------- */
					if (paper && !paper.dataset.fontsizeUpdated) {
						const resize = () => {
							paper.style.fontSize =
								window.innerWidth < 768 ? '24px' : '30px';
						};
						resize();
						window.addEventListener('resize', resize);
						paper.dataset.fontsizeUpdated = 'true';
					}
				});

			/* ---------- NEW: keep header summary in sync -------------- */
			updateHeaderSummary();
		}
	}

	/* ------------------------------------------------------------------ */
	/* 3. Kick-off – run once for existing DOM, then observe              */
	/* ------------------------------------------------------------------ */
	updateHeaderSummary(); // handles markup already present
	new MutationObserver(handleMutations).observe(document.body, {
		childList: true,
		subtree: true,
	});
})();